/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkActionCandidatesResponse } from './InstanceBulkActionCandidatesResponse';
import {
    InstanceBulkActionCandidatesResponseFromJSON,
    InstanceBulkActionCandidatesResponseFromJSONTyped,
    InstanceBulkActionCandidatesResponseToJSON,
    InstanceBulkActionCandidatesResponseToJSONTyped,
} from './InstanceBulkActionCandidatesResponse';

/**
 * 
 * @export
 * @interface FindInstanceBulkDecisionCandidates200Response
 */
export interface FindInstanceBulkDecisionCandidates200Response {
    /**
     * 
     */
    data?: InstanceBulkActionCandidatesResponse;
}

/**
 * Check if a given object implements the FindInstanceBulkDecisionCandidates200Response interface.
 */
export function instanceOfFindInstanceBulkDecisionCandidates200Response(value: object): value is FindInstanceBulkDecisionCandidates200Response {
    return true;
}

export function FindInstanceBulkDecisionCandidates200ResponseFromJSON(json: any): FindInstanceBulkDecisionCandidates200Response {
    return FindInstanceBulkDecisionCandidates200ResponseFromJSONTyped(json, false);
}

export function FindInstanceBulkDecisionCandidates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindInstanceBulkDecisionCandidates200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InstanceBulkActionCandidatesResponseFromJSON(json['data']),
    };
}

export function FindInstanceBulkDecisionCandidates200ResponseToJSON(json: any): FindInstanceBulkDecisionCandidates200Response {
    return FindInstanceBulkDecisionCandidates200ResponseToJSONTyped(json, false);
}

export function FindInstanceBulkDecisionCandidates200ResponseToJSONTyped(value?: FindInstanceBulkDecisionCandidates200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InstanceBulkActionCandidatesResponseToJSON(value['data']),
    };
}

